import MicroModal from 'micromodal'; 

// JS PRODUCTS

/**
 * TO DO
 * =========================================
 */

export function product() {

	// Els
	const productForm = document.getElementById('AddToCartForm');
	const product = JSON.parse(productForm.querySelector('#js-product').value);
	const optionRadios = Array.prototype.slice.call(productForm.querySelectorAll('[type="radio"]'));
	const priceEl = productForm.querySelector('.js-price');
	const productSelect = productForm.querySelector('#productSelect');
	const productRadios = productForm.querySelector('.product-radios');
	const moneyFormat = productForm.querySelector('#js-money-format').value
	const submitBtn = productForm.querySelector('#AddToCart');
	const qtySelect = productForm.querySelector('#Quantity');
	const msgEl = productForm.querySelector('#message');
	const cartCount = Array.prototype.slice.call(document.querySelectorAll('.cart-link__count'));
	// Vars
	const variants = product.variants;
	const productVariants = variants.map(variant => {
		variant.inventory_quantity = parseInt(document.querySelector(`[name="${variant.id}"]`).value)
		return variant
	})
	const lowStockThreshold = parseInt(document.getElementById('low-stock-threshold').value);
	const maxQty = parseInt(document.getElementById('max-qty').value);

	const soldOutMsg = document.getElementById('sold-out-msg').value;
	const lowStockMsg = document.getElementById('low-stock-msg').value;

	MicroModal.init({
		closeTrigger: 'data-custom-close'
	});

	optionRadios.forEach(radio => {
		radio.addEventListener('change', handleUpdate, false)
	});

	productForm.addEventListener('submit', function(e) {
		e.preventDefault();
		
		submitBtn.classList.add('is-loading');
		submitBtn.innerHTML = 'adding&hellip;';

		const props = {
			"shipping_interval_frequency": document.querySelector('#rc_shipping_interval_frequency')?  document.querySelector('#rc_shipping_interval_frequency').value : null,
			"shipping_interval_unit_type": document.querySelector('#rc_shipping_interval_unit_type') ? document.querySelector('#rc_shipping_interval_unit_type').value : null
		}

		const addData = {
			id: getVariant(getOptions()).id,
			quantity: parseInt(qtySelect.value)
		}

		if (props["shipping_interval_frequency"]) {
			addData.properties = props;
		}

		addToCart(addData);

		return;

	})

	function getOptions() {
		let options = [];
		optionRadios.forEach(radio => {
			if (!radio.checked) {
				return;
			}
			options.push(radio.value)

		});
		
		
		return options.join(' / ');
	}

	function getVariant(options) {
		const variant = productVariants.find(variant => variant.title === options);

		return {
			id: variant ? variant.id : null,
			price: variant ? variant.price : null,
			stock: variant ? variant.inventory_quantity : null,
			inventory: variant ? variant.inventory_management : null
		}
	}

	// Need to run this on inint
	function handleUpdate() {

		const variant = getVariant(getOptions());

		console.log(variant);

		if (!variant.id) {
			return handleUnavailable();
		}

		if (variant.stock === 0 && variant.inventory) {
			return handleSoldOut();
		}

		if ((variant.stock <= lowStockThreshold && variant.inventory) || (variant.stock < maxQty && variant.inventory))  {
			return handleLowStock(variant);
		}

		return handleOk(variant);

	}

	function handleSoldOut() {

		submitBtn.setAttribute('disabled', 'disabled');

		updateMsg(soldOutMsg);

		return

	}
	
	function handleUnavailable() {

		submitBtn.setAttribute('disabled', 'disabled');

		updateMsg('Sorry. Not available in your chosen combination');

		return

	}

	function handleLowStock(variant) {

		let msg = lowStockMsg.replace('####', variant.stock)
		// set max range on qty select
		if (variant.stock < maxQty) {
			
			fillQtySelect(variant.stock);

		}
		// show message
		updateMsg(msg); 

		return;

	}

	function handleOk(variant) {
		submitBtn.removeAttribute('disabled');
		setPrice(variant);
		fillQtySelect(maxQty)
		hideMsg();
	}


	function setPrice(variant) {
		priceEl.innerHTML = Shopify.formatMoney(variant.price, moneyFormat);
	}

	function fillQtySelect(num) {
		let arr = [...Array(num).keys()]
		let opts = arr.map((el, i) => {
			return `<option value="${i+1}">${i+1}</option>`;
		})
		qtySelect.innerHTML = opts.join('');
		return;
	} 

	function updateMsg(msg) {
		msgEl.classList.add('is-active')
		msgEl.innerHTML = msg;
		return;
	}

	function hideMsg() {
		msgEl.innerHTML = '';
		msgEl.classList.remove('is-active');
		return
	}

	function addToCart(items) {
		
		fetch('/cart/add.js', {

			body: JSON.stringify(items),
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
			},
			method: 'POST'
			
		}).then(function(response) {
			
			return response.json();
			
		}).then(function(json) {

			/* we have JSON */
			
			// Shopify error which is not returned as an error 😫
			if (json.status === 422) {
				console.error(json)
				updateMsg(`Sorry. Something went wrong. ${json.description} Please try again. If the problem persists, please <a href="/pages/contact">Contact us</a>`)
				submitBtn.classList.remove('is-loading');
				submitBtn.innerHTML = 'Add to basket';
				return
			}
			
			// SUCCESS
			submitBtn.classList.remove('is-loading');
			submitBtn.innerHTML = 'Add to basket';
			updateCartCount()
			MicroModal.show('add-to-cart-modal'); 
			
		}).catch(function(err) {

			/* uh oh, we have a REAL error. */
			
			console.error('add to cart err', err)
			updateMsg(`Sorry. Something went wrong. Please try again. If the problem persists, please <a href="/pages/contact">Contact us</a>`);
			submitBtn.classList.remove('is-loading');
			submitBtn.innerHTML = 'Add to basket';

		});
	}

	function updateCartCount() {
		fetch('/cart.json')

		.then(function(response) {

			return response.json();
			
		}).then(function(cart) {

			/* we have JSON */
			
			// Update the desktop and mobile cart counts
			cartCount.forEach(el => {
				el.innerHTML = cart.item_count
			})

		}).catch(function(err) {

			/* uh oh, we have error. */
			
			console.error(err);
			updateMsg(`Sorry, Something went wrong. Please try again. If the problem persists, please <a href="/pages/contact">Contact us</a>`);

		});
	}

	function init() {

		productSelect.classList.add('hidden');
		productRadios.classList.remove('hidden');

		handleUpdate();

	}

	init();

}